import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      Copyright© 2019-2026 N-Sports tracking Lab, LLC.
    </div>
  );
}

export default Footer;
